import React from "react";
import Selena from "../../assets/img/boxSelena.webp";
import styles from "./eventEmptyState.module.scss";
import { IconCalendarSVG } from "../../assets/img/iconCalendarSVG";
import SonicLink from "../../common/routing/SonicLink";

export const EventEmptyState: React.FC = () => {
  return (
    <div className={styles["p-pempty__wrapper"]}>
      <p className={styles["p-pempty__nocontents"]}>
        <IconCalendarSVG width={100} height={100} />
        現在掲載中のイベントはありません
      </p>
      <div className={styles["p-pempty__make"]}>
        <img className={styles["p-pempty__img"]} src={Selena} />
        <div>
          <h2 className={styles["p-pempty__ttl"]}>
            イベントを掲載してみませんか？
          </h2>
          <p className={styles["p-pempty__text"]}>
            イベントを掲載することでユーザーへイベントを告知できます。
          </p>
        </div>
      </div>
      <SonicLink
        to="/mypage/event-settings"
        className={styles["p-pempty__link"]}
      >
        マイページでイベントを作成してみる
      </SonicLink>
    </div>
  );
};

export default EventEmptyState;
